"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_cookie_1 = require("react-cookie");
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
const detailed_credit_application_1 = require("./detailed-credit-application");
const GlobalSearch_1 = __importDefault(require("./global-search/views/GlobalSearch"));
const Layout_1 = __importDefault(require("./Layout"));
const LayoutPublic_1 = __importDefault(require("./LayoutPublic"));
const locations_1 = require("./locations");
const plaid_identity_verification_1 = require("./plaid-identity-verification");
const plan_management_1 = require("./plan-management");
const Views = __importStar(require("./views"));
function Routes() {
    // Hooks
    const [cookies] = (0, react_cookie_1.useCookies)(['portalUser']);
    // Func - appPath
    const appPath = (tmpPath, tmpQuery = null) => {
        if (tmpQuery) {
            return `${(0, config_1.makePath)(config_1.PATH.INTERNAL_PORTAL, config_1.PATH.PLAN_MANAGEMENT)}${tmpQuery}`;
        }
        else {
            return (0, config_1.makePath)(config_1.PATH.INTERNAL_PORTAL, tmpPath);
        }
    };
    if (cookies.portalUser) {
        return ((0, jsx_runtime_1.jsx)(Layout_1.default, { children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: appPath(config_1.PATH.PLAID_IDENTITY_VERIFICATION), exact: true, children: (0, jsx_runtime_1.jsx)(plaid_identity_verification_1.Routes, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: appPath(`${config_1.PATH.CREDIT_APPLICATION_DETAILED}/:id`), children: (0, jsx_runtime_1.jsx)(detailed_credit_application_1.Routes, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: appPath(`${config_1.PATH.LOCATIONS}`), children: (0, jsx_runtime_1.jsx)(locations_1.Routes, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: appPath(config_1.PATH.PLAN_MANAGEMENT, '/*'), exact: true, children: (0, jsx_runtime_1.jsx)(plan_management_1.Routes, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: appPath(config_1.PATH.GLOBAL_SEARCH), exact: true, children: (0, jsx_runtime_1.jsx)(GlobalSearch_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "*", exact: true, children: (0, jsx_runtime_1.jsx)(Views.Home, {}) })] }) }));
    }
    else {
        return ((0, jsx_runtime_1.jsx)(LayoutPublic_1.default, { children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: appPath('/logout'), exact: true, children: (0, jsx_runtime_1.jsx)(Views.Logout, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: appPath('/signout'), exact: true, children: (0, jsx_runtime_1.jsx)(Views.Logout, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: appPath('/login'), exact: true, children: (0, jsx_runtime_1.jsx)(Views.Login, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: appPath('*'), exact: true, children: (0, jsx_runtime_1.jsx)(Views.Login, {}) })] }) }));
    }
}
exports.default = Routes;
